module.exports = __webpack_public_path__ + "media/images/site/trophies-cb7ec46c4c38ae5ec9c47cc467ab086e.svg";